/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';
import AppStatic from "@/utils/AppStatic";
import Image from 'next/image';
import {wedsnapURL} from '@/utils/AppConfig';
import {PiArrowBendLeftDownLight} from "react-icons/pi";
import {FaEye, FaShoppingBag} from "react-icons/fa";
import {TbChevronsDown} from "react-icons/tb";
import AppButton from "@/components/button/AppButton";
import AppWedSnapFeatures from "@/components/wedsnap/AppWedSnapFeatures";
import wedsnapScan from "@/assets/images/wedsnap/wedsnap-scan.webp";

const AppWedSnap = () => {
    const [showWedSnapFeatures, setShowWedSnapFeatures] = React.useState(false);
    return (
        <>
            <div className="relative text-[#EBE6DE] z-10">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-2">
                    <div className="flex items-center justify-center flex-wrap">
                        <Image className="w-full max-w-[500px]" src={wedsnapScan} alt="Wedsnap by Weddify" loading="lazy"/>
                    </div>
                    <div>
                        <h3 className="mt-10 text-6xl font-bold md:text-7xl">{AppStatic.wedSnapMainHeading.ro.translation}</h3>
                        <p className="mb-6 mt-10 font-thin tracking-wider">{AppStatic.wedSnapPropositionSecond.ro.translation}</p>
                        <p className="mb-10 font-thin tracking-wider">{AppStatic.wedSnapPropositionThird.ro.translation}</p>
                        <div className="mt-8 md:mb-4 lg:mb-10 flex flex-wrap gap-2">
                            <AppButton data={{
                                action: "scroll",
                                id: "app-plans",
                                name: AppStatic.mainBuyCta.ro.translation,
                                icon: <FaShoppingBag className="f-2"/>,
                                extraClass: "border-white!"
                            }}/>
                            <AppButton data={{
                                action: "link",
                                link: wedsnapURL,
                                extraClass: "bg-white! text-black! border-white!",
                                blank: true,
                                name: AppStatic.wedSnapPreviewCta.ro.translation,
                                icon: <FaEye className="f-2"/>
                            }}/>
                        </div>
                    </div>
                </div>
                {!showWedSnapFeatures && (
                    <div
                        className="cursor-pointer justify-center text-xl mt-4 mb-10 flex items-center gap-1 hover:opacity-60"
                        onClick={() => {
                            setShowWedSnapFeatures(!showWedSnapFeatures)
                        }}>
                        {AppStatic.wedSnapFeaturesCta.ro.translation} <TbChevronsDown className="text-4xl"/>
                    </div>
                )}
                {showWedSnapFeatures && (
                    <div className="relative mt-14 mb-10 sm:mt-16">
                        <AppWedSnapFeatures/>
                        <div
                            className="flex w-full flex-wrap gap-0 mb-6 text-3xl md:text-4xl lg:text-6xl mt-4 font-bold uppercase">
                            <p>{AppStatic.wedSnapHashtagFirst.ro.translation}</p>
                            <p>{AppStatic.wedSnapHashtagSecond.ro.translation}</p>
                            <p>{AppStatic.wedSnapHashtagThird.ro.translation}</p>
                        </div>
                    </div>
                )}
                <div className="pt-10 flex text-sm gap-2 justify-center items-center">
                    <PiArrowBendLeftDownLight/> {AppStatic.appViewAIBlock.ro.translation}
                </div>
            </div>
        </>
    );
}

export default AppWedSnap;
